import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { AuthSessionService } from '../services/auth-session.service';
import { AuthAttemptService } from '../services/auth-attempt.service';
import { PostLoginRedirectService } from '../services/post-login-redirect.service';
import { TokenRefreshService } from '../services/token-refresh.service';

/**
 * Resolves the OIDC session once, before the router's first navigation.
 *
 * This is the hand-rolled equivalent of the library's
 * `withAppInitializerAuthCheck()` feature: same effect, but built on
 * `provideAppInitializer` instead of the deprecated `APP_INITIALIZER` token,
 * and it keeps the `checkAuth()` result so routed components can act on it
 * instead of re-deriving the auth state.
 */
export function provideAuthSession(): EnvironmentProviders {
  return makeEnvironmentProviders([
    AuthSessionService,
    AuthAttemptService,
    PostLoginRedirectService,
    TokenRefreshService,
    provideAppInitializer(() => inject(AuthSessionService).initialize()),
  ]);
}
